import { useState } from 'react';
import { isContentStateEmpty } from 'ricos-content';
import { isEqual } from 'lodash';
const getInitialFormState = (content) => ({
    content,
    isBusy: false,
    editorKey: Date.now(),
});
const getIsEmpty = (content) => !content || isContentStateEmpty(content);
export const useContentForm = ({ initialContent, onTyping, }) => {
    const [state, setState] = useState(getInitialFormState(initialContent));
    return Object.assign(Object.assign({}, state), { onChange: (content) => {
            setState((prevState) => {
                if (state.editorKey !== prevState.editorKey) {
                    // In some cases editor calls 'onChange' even after it already should be remounted
                    return prevState;
                }
                if (onTyping && !getIsEmpty(content)) {
                    // @TODO: later versions of ricos will have isContentStateEqual.
                    // Also contentTraits are available on editor ref, but not working as expected for the moment, so falling back to isEqual
                    const contentChanged = !isEqual(content, prevState.content);
                    contentChanged && onTyping();
                }
                return { content, isBusy: prevState.isBusy, editorKey: prevState.editorKey };
            });
        }, onBusyChange: (isBusy) => {
            setState((prevState) => {
                if (state.editorKey !== prevState.editorKey) {
                    return prevState;
                }
                return {
                    content: prevState.content,
                    isBusy,
                    editorKey: prevState.editorKey,
                };
            });
        }, reset: () => setState(getInitialFormState()), getIsValid: () => !state.isBusy && !getIsEmpty(state.content), getIsEmpty: () => getIsEmpty(state.content) });
};
//# sourceMappingURL=use-content-form.js.map